import Reflux from 'reflux';
import BaseMixin from 'flux/stores/BaseMixin';
import ServerTimeStore from 'flux/stores/ServerTimeStore';

/**
 * Server Time Ticker Store
 *
 */
export default Reflux.createStore({
  mixins: [BaseMixin],

  init() {
    this.setState(new Date().getTime());

    this.listenTo(ServerTimeStore, 'onServerTimeSync');

    this._interval = setInterval(() => {
      this.setStateAndTrigger(this.getState() + 1000);
    }, 1000);
  },

  onServerTimeSync(date) {
    this.setState(date);
  },
});
